/* CCC Relaunch 2027 – «Passt zu meiner Maschine».
   Kollektion: Auswahl filtert über den Modell-Tag und merkt sich die Maschine im Browser.
   Produktseite: zeigt «Passt zu …» und hebt die gemerkte Maschine hervor.
   2026-10-01 v2: Das Maschinenprofil (Siebträger-Durchmesser, Brühgruppe, Marke), das ccc27-fitg.js beim
   Auswählen merkt, prüft auf Produktseiten auch Zubehör ohne Modell-Tag – nur über ausdrückliche Tags:
   «Durchmesser: 58 mm» (Tamper, Siebe, Puck-Siebe …), «Brühgruppe: E61», Siebträger über die Kollektion
   siebtraeger-portafilter (snippets/ccc27-fit-data). Passt es nicht, steht ein ruhiger Hinweis statt «Passt». */
(function () {
  if (window.cccMachineReady) return;
  window.cccMachineReady = true;
  var KEY = 'ccc27-machine';
  var T = window.ccc27T || {};
  var LANG = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var TX = {
    de: { fits_yours: 'Passt zu deiner <b>{n}</b>', also_fits: ' · auch zu {list}', fits: '<b>Passt zu</b> {list}', your_machine: 'Deine Maschine: <b>{n}</b> · <a href="{u}">Nur Passendes zeigen ›</a>', yes_d: 'Passt zu deiner <b>{n}</b> ({d} mm)', no_d: '<b>Hinweis:</b> für {list} mm – deine {n} braucht {d} mm.', no_e61: '<b>Hinweis:</b> für E61-Brühgruppen – deine {n} hat eine andere Brühgruppe.', no_si: '<b>Hinweis:</b> passt nicht an die Straight-In-Gruppe deiner {n}.' },
    en: { fits_yours: 'Fits your <b>{n}</b>', also_fits: ' · also fits {list}', fits: '<b>Fits</b> {list}', your_machine: 'Your machine: <b>{n}</b> · <a href="{u}">Show matching items only ›</a>', yes_d: 'Fits your <b>{n}</b> ({d} mm)', no_d: '<b>Note:</b> for {list} mm – your {n} needs {d} mm.', no_e61: '<b>Note:</b> for E61 groups – your {n} has a different group.', no_si: '<b>Note:</b> does not fit the straight-in group of your {n}.' },
    fr: { fits_yours: 'Compatible avec <b>{n}</b>', also_fits: ' · aussi avec {list}', fits: '<b>Compatible avec</b> {list}', your_machine: 'Ta machine : <b>{n}</b> · <a href="{u}">Afficher seulement le compatible ›</a>', yes_d: 'Compatible avec <b>{n}</b> ({d} mm)', no_d: '<b>Remarque :</b> pour {list} mm – {n} demande {d} mm.', no_e61: '<b>Remarque :</b> pour groupes E61 – {n} a un autre groupe.', no_si: '<b>Remarque :</b> ne convient pas au groupe Straight-In de {n}.' },
    it: { fits_yours: 'Compatibile con <b>{n}</b>', also_fits: ' · anche con {list}', fits: '<b>Compatibile con</b> {list}', your_machine: 'La tua macchina: <b>{n}</b> · <a href="{u}">Mostra solo i compatibili ›</a>', yes_d: 'Compatibile con <b>{n}</b> ({d} mm)', no_d: '<b>Nota:</b> per {list} mm – {n} richiede {d} mm.', no_e61: '<b>Nota:</b> per gruppi E61 – {n} ha un altro gruppo.', no_si: '<b>Nota:</b> non adatto al gruppo Straight-In di {n}.' },
    es: { fits_yours: 'Compatible con <b>{n}</b>', also_fits: ' · también con {list}', fits: '<b>Compatible con</b> {list}', your_machine: 'Tu máquina: <b>{n}</b> · <a href="{u}">Mostrar solo lo compatible ›</a>', yes_d: 'Compatible con <b>{n}</b> ({d} mm)', no_d: '<b>Nota:</b> para {list} mm – {n} necesita {d} mm.', no_e61: '<b>Nota:</b> para grupos E61 – {n} tiene otro grupo.', no_si: '<b>Nota:</b> no es compatible con el grupo Straight-In de {n}.' },
    pt: { fits_yours: 'Compatível com <b>{n}</b>', also_fits: ' · também com {list}', fits: '<b>Compatível com</b> {list}', your_machine: 'A tua máquina: <b>{n}</b> · <a href="{u}">Mostrar só o compatível ›</a>', yes_d: 'Compatível com <b>{n}</b> ({d} mm)', no_d: '<b>Nota:</b> para {list} mm – {n} precisa de {d} mm.', no_e61: '<b>Nota:</b> para grupos E61 – {n} tem outro grupo.', no_si: '<b>Nota:</b> não serve no grupo Straight-In de {n}.' }
  };
  var TL = TX[LANG] || TX.de;
  function tr(k, d, v) {
    var s = T[k] || TL[k] || d;
    if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); });
    return s;
  }
  /* Modellnamen wie in ccc27-fitg.js: Teile, die ein anderes Gerät nennen, bekommen kein Urteil */
  var ALIAS = {
    /* 01.10.2026: Appartamento (klassisch) und Appartamento TCA, Linea Mini (alt) und Linea Mini R sind getrennte Modelle */
    'Appartamento': ['Appartamento'], 'Appartamento TCA': ['Appartamento TCA', 'App. TCA', 'TCA'],
    'Cinquantotto': ['Cinquantotto', 'R58', 'R 58'], 'R58': ['R58', 'R 58', 'Cinquantotto'],
    'R60': ['R60', 'R 60', 'R60V'], 'Linea Mini': ['Linea Mini', 'Linea Mini/R', 'La Marzocco Mini'], 'Linea Mini R': ['Linea Mini R', 'Mini R', 'Linea Mini/R'], 'Linea Micra': ['Linea Micra', 'Micra'],
    'Linea PB': ['Linea PB', 'PB X'], 'LEVA': ['Leva', 'LEVA'], 'Linea Classic': ['Linea Classic']
  };
  var OTHER_WORDS = ['Appartamento', 'Appartamento TCA', 'App. TCA', 'TCA', 'Linea Mini R', 'Linea Mini/R', 'La Marzocco Mini', 'Bicocca', 'Boxer', 'Cellini', 'Cinquantotto', 'Giotto', 'Mozzafiato', 'R58', 'R60', 'Porta Via', 'NOW', 'Epica',
    'R58 Tune', 'Fausto', 'Faustino', 'Giannino', 'Super Fausto', 'GS3', 'KB90', 'Leva', 'LEVA', 'Manument Leva', 'Linea Classic', 'Linea Micra', 'Micra', 'Linea Mini', 'Mini R', 'Linea PB', 'PB X', 'Strada', 'GB5',
    'Pico', 'Swift', 'Superkop', 'Aram', 'Cremina', 'Maximatic', 'Mina', 'Manument', 'Robot', 'Specialista', 'Dedica', 'Silvia',
    'Pro und Classic', 'Flair Pro', 'Flair Classic', 'Neo', 'Signature', 'Pro 2', 'Pro2', 'PRO 2', 'PRO 3', '2 GO'];
  function rx(w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function hasModel(t, w) { return new RegExp('(^|[^A-Za-z0-9])' + rx(w) + '([^A-Za-z0-9]|$)').test(t || ''); }
  function aliases(m) { return ALIAS[m] || [m]; }
  function mentionsOwn(t, model) {
    var own = aliases(model), s = t || '';
    OTHER_WORDS.forEach(function (o) { own.forEach(function (w) { if (o !== w && o.indexOf(w) >= 0 && own.indexOf(o) < 0) s = s.replace(new RegExp(rx(o), 'g'), ' '); }); });
    return own.some(function (w) { return hasModel(s, w); });
  }
  function forOther(t, model) {
    if (mentionsOwn(t, model)) return false;
    var own = aliases(model);
    return OTHER_WORDS.some(function (w) { return own.indexOf(w) < 0 && hasModel(t, w); });
  }
  function num(d) { return String(d).replace('.', LANG === 'en' ? '.' : ','); }

  function get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function set(v) {
    try {
      if (v) {
        /* Profil (von ccc27-fitg.js) behalten, solange es dieselbe Maschine ist */
        var old = get();
        if (old && old.h === v.h && old.p && !v.p) v.p = old.p;
        localStorage.setItem(KEY, JSON.stringify(v));
      } else localStorage.removeItem(KEY);
    } catch (e) {}
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function collection() {
    document.querySelectorAll('[data-ccc-machine]').forEach(function (box) {
      if (box.getAttribute('data-ready')) return;
      box.setAttribute('data-ready', '1');
      var base = box.getAttribute('data-base');
      var sel = box.querySelector('[data-ccc-machine-select]');
      var hint = box.querySelector('.ccc27-machine__hint');
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        if (sel.value) {
          set({ h: sel.value, n: o.getAttribute('data-name') });
          window.location.href = base + '/' + sel.value;
        } else {
          set(null);
          window.location.href = base;
        }
      });
      var reset = box.querySelector('[data-ccc-machine-reset]');
      if (reset) reset.addEventListener('click', function () { set(null); });
      var saved = get();
      if (!sel.value && saved && sel.querySelector('option[value="' + saved.h + '"]')) {
        hint.innerHTML = tr('your_machine', 'Deine Maschine: <b>{n}</b> · <a href="{u}">Nur Passendes zeigen ›</a>', { n: esc(saved.n), u: esc(base + '/' + saved.h) });
      }
      if (sel.value) {
        var o2 = sel.options[sel.selectedIndex];
        set({ h: sel.value, n: o2.getAttribute('data-name') });
      }
    });
  }

  function product() {
    var host = document.querySelector('block-buy-buttons');
    if (!host || host.querySelector('.ccc27-fit')) return;
    var models = [], fp = null;
    var el = document.getElementById('ccc27-fit');
    if (el) { try { models = JSON.parse(el.textContent) || []; } catch (e) { models = []; } }
    var el2 = document.getElementById('ccc27-fit-p');
    if (el2) { try { fp = JSON.parse(el2.textContent); } catch (e) { fp = null; } }
    var saved = get();
    var p = document.createElement('p');
    p.className = 'ccc27-fit';

    if (models.length) {
      var match = saved && models.some(function (m) { return m.h === saved.h; });
      if (match) {
        p.classList.add('is-match');
        p.innerHTML = '<span class="ccc27-dot" aria-hidden="true"></span>' + tr('fits_yours', 'Passt zu deiner <b>{n}</b>', { n: esc(saved.n) });
        if (models.length > 1) p.innerHTML += '<span class="ccc27-fit__more">' + tr('also_fits', ' · auch zu {list}', { list: models.filter(function (m) { return m.h !== saved.h; }).map(function (m) { return esc(m.n); }).join(', ') }) + '</span>';
      } else {
        p.innerHTML = tr('fits', '<b>Passt zu</b> {list}', { list: models.map(function (m) { return esc(m.n); }).join(', ') });
      }
      host.insertBefore(p, host.firstChild);
      return;
    }

    /* Ohne Modell-Tag: nur mit gemerktem Maschinenprofil und ausdrücklichen Tags urteilen */
    if (!fp || !saved || !saved.p || saved.p.k !== 'm') return;
    var mp = saved.p, n = esc(saved.n), verdict = null, dTxt = '', list = '';
    if (forOther(fp.t, saved.n)) return;
    if (fp.pf) {
      var straight = /straight.?in/i.test(fp.t || '');
      if (mp.si) verdict = straight ? 'yes' : ((fp.v === mp.v || fp.e61) ? 'no_si' : null);
      else if (straight) verdict = null;
      else if (fp.e61) verdict = mp.g === 'e61' ? 'yes' : (mp.g ? 'no_e61' : null);
      else if (fp.v && fp.v === mp.v && /^(e61|sat|int|lever)$/.test(mp.g || '')) verdict = 'yes';
    } else if (fp.d && fp.d.length && mp.d) {
      var ds = fp.d.map(function (x) { return parseFloat(String(x).replace(',', '.')); }).filter(function (x) { return !isNaN(x) && x >= 40 && x <= 70; });
      if (ds.length) {
        /* KB90: La Marzocco nennt den 58,5-mm-Tamper nicht kompatibel – zwischen 58,4 und 58,7 mm darum kein Urteil */
        var max = mp.si ? 58.4 : mp.d + 0.7;
        var hit = ds.filter(function (x) { return x >= mp.d - 0.1 && x <= max; });
        var grey = mp.si && ds.some(function (x) { return x > 58.4 && x <= mp.d + 0.7; });
        if (hit.length && !mp.xr) { verdict = 'yes_d'; dTxt = num(hit[0]); }
        else if (!hit.length && !grey) { verdict = 'no_d'; list = ds.map(num).join(' / '); }
        /* Leva: verstärkte Siebe nötig – Zubehör mit passendem Durchmesser bekommt kein «Passt» (nur Modell-Tags) */
      }
    } else if (fp.e61 && mp.g === 'e61') {
      verdict = 'yes';
    }
    if (!verdict) return;
    if (verdict === 'yes' || verdict === 'yes_d') {
      p.classList.add('is-match');
      p.innerHTML = '<span class="ccc27-dot" aria-hidden="true"></span>' + (verdict === 'yes'
        ? tr('fits_yours', 'Passt zu deiner <b>{n}</b>', { n: n })
        : tr('yes_d', '', { n: n, d: dTxt }));
    } else {
      p.classList.add('is-warn');
      p.innerHTML = tr(verdict, '', { n: n, d: num(mp.d), list: list });
    }
    host.insertBefore(p, host.firstChild);
  }

  function start() { collection(); product(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
})();
